// extracted by mini-css-extract-plugin
export default {"backButton":"BR0VL","input":"EnTED"};